import React from "react";
import Button from "@mui/material/Button";

const IconButton = ({ text, icon, ...props }) => (
  <Button {...props}>
    {icon}
    {text?.length ? (
      <span className="icon-button-text" style={{ marginLeft: "0.25rem" }}>
        {text}
      </span>
    ) : null}
  </Button>
);

export default IconButton;
